import React, { Component } from 'react'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import DirectorListUI from './DirectorListUI.js'

class DirectorListSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      selectedUser: null,
      updateModeTermSheet: false,
      updateModeSanction: false,
      selectedLoan: null
    }
  }

  render() {
    return (
      <DirectorListUI
        context={this.props.context}
        errorList={this.state.errorList}
        directorList={this.props.directorList}
        selectedUser={this.state.selectedUser}
        updateModeTermSheet={this.state.updateModeTermSheet}
        updateModeSanction={this.state.updateModeSanction}
        selectedLoan={this.state.selectedLoan}
        loan={this.props.loan}
        // events
        onRefreshClick={this.props.onRefreshClick}
        onUpdateClick={this.onUpdateClick}
        onCancelClick={this.onCancelClick}
        onMoveUpClick={this.onMoveUpClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
  }

  onUpdateClick = (event) => {
    let userId = event.currentTarget.getAttribute('data-userid')
    console.log(userId);
    let selectedUser = this.props.directorList.filter(p => p.userId === userId)[0]
    this.setState({ updateModeTermSheet: true, updateModeSanction: false, selectedUser: selectedUser })
  }

  onCancelClick = () => {
    this.setState({ updateModeTermSheet: false, updateModeSanction: false, errorList: null })
  }

  onMoveUpClick = (event) => {
    let movingUp = this.state.movingUp
    if (movingUp)
      return

    let userId = event.currentTarget.getAttribute('data-row-id')
    this.setState({ movingUp: true, selectedLoan: this.props.loan.loanId })

    RestApiUtils.put(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/users/${userId}/promote`,
      this.onMoveUpClickCallback, {}
    )
  }

  onMoveUpClickCallback = (response) => {
    let errorList = []
    this.setState({ movingUp: false , errorList: errorList })
    if (response.errorList.length === 0) {
      this.props.onRefreshClick('noBusy')
    }
  }
}

export default DirectorListSF
